// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f4aebfb2","802":"afe8b586"}[chunkId] + ".chunk.js";
};